import React, { useState } from "react";

import useWindowSize from "../hooks/useWindowSize";
import { IconName, Promotion } from "../types";
import EllipsisLoader from "./EllipsisLoader";
import Icon from "./Icon";
import MoreDetailsBtn from "./MoreDetailsBtn";
import Selectable from "./Selectable";

const PromotionBanner = (props: {
  promotion: Promotion;
  selected: boolean;
  selectableHidden?: boolean;
  onClick?: (promotion: Promotion) => void;
  onClickMoreDetails?: (promotion: Promotion) => void;
  showPopout: boolean;
}) => {
  const windowSize = useWindowSize();
  const [isPopoutVisible, setIsPopoutVisible] = useState(true);

  const onClickMoreDetails = () => {
    if (props.onClickMoreDetails) {
      props.onClickMoreDetails(props.promotion);
    }
  };

  const closePopout = () => {
    setIsPopoutVisible(false);
  };

  return (
    <Selectable
      selected={props.selected}
      hidden={props.selectableHidden}
      insetTick={windowSize.width < 768}
      className={"pyht-special-offer-banner"}
    >
      <>
        <div
          className={"inner"}
          role={"button"}
          onClick={() => props.onClick && props.onClick(props.promotion)}
        >
          <div className={"hero-container"}>
            <EllipsisLoader />
            <img
              className={"hero hero-desktop"}
              src={props.promotion.background_image_desktop}
              alt={""}
            />
            <img
              className={"hero hero-mobile"}
              src={props.promotion.background_image_mobile}
              alt={""}
            />
            {props.onClickMoreDetails && (
              <MoreDetailsBtn
                onClick={onClickMoreDetails}
                preventDefault={true}
              />
            )}
          </div>
        </div>
        {props.showPopout && isPopoutVisible && props.promotion.show_popout && (
          <div className="promo-popout">
            <button type="button" role="button" className="popout-close" onClick={closePopout}>
              <Icon name={IconName.CLOSE} />
            </button>
            <div className="popout-text" dangerouslySetInnerHTML={{ __html: props.promotion.popout_copy }}></div>
          </div>
        )}
      </>
    </Selectable>
  );
};

export default PromotionBanner;
